import { NgModule } from '@angular/core';
import { ToolsComponent } from './tools.component';
import { CommonHeaderComponent } from './common-header/common-header.component';
import { CommonFooterComponent } from './common-footer/common-footer.component';
import {SharedService} from '../lib/shared/shared.service'
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
@NgModule({
  entryComponents: [CommonHeaderComponent, CommonFooterComponent],
  declarations: [ToolsComponent, CommonHeaderComponent, CommonFooterComponent],
  imports: [
    CommonModule,BrowserModule
  ],
  exports: [ToolsComponent, CommonHeaderComponent, CommonFooterComponent],
  providers: [SharedService],
})
export class ToolsModule { }
